export const parseCurrency = (
  currencyValue: string,
  currencySymbol: string,
  thousandSeparator: string
): number => {
  if(currencyValue === undefined || currencyValue.length === 0){
    return 0;
  }
  const withoutCurrencySymbol = currencyValue.replace(currencySymbol, "");
  const thousandSeparatprRegex = new RegExp(`\\${thousandSeparator}`, "g");
  const withoutThousandSeparator = withoutCurrencySymbol.replace(
    thousandSeparatprRegex,
    ""
  );
  return parseFloat(withoutThousandSeparator);
};

export const currencyFormat = (value: number): string => {
  const currencyFormatOptions: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  };
  const currencyFormat = new Intl.NumberFormat("es-CO", currencyFormatOptions);
  return currencyFormat.format(value);
};

export const bytesToMegas = (bytes: number): number => {
  return bytes / 1024 ** 2;
};
